import { Subject } from '../../../../../../models/subjects/subject';

export class SubjectDialogData {
    mode: string;
    subject: Subject;
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/subjects/components/add-subejct/subject-dialog-data.ts